export interface PassType {
	Id: number | null;
	Name: string;
	Description: string;
	Active: boolean;
}

export const PASS_TYPE_INITIAL_VALUES: PassType = {
	Id: null,
	Name: "",
	Description: "",
	Active: true,
};
